import { MinzeElement } from "minze";

export interface TjYtPlayIcon {}

export class TjYtPlayIcon extends MinzeElement {
  html = () => `
    <svg width="46" height="32" viewBox="0 0 46 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2388_1553)">
        <path d="M44.7601 4.99718C44.2333 3.02916 42.6867 1.4826 40.7187 0.955786C37.1514 0 22.8561 0 22.8561 0C22.8561 0 8.56067 0 4.99717 0.955786C3.02916 1.4826 1.4826 3.02916 0.955785 4.99718C0 8.56068 0 16 0 16C0 16 0 23.4393 0.955785 27.0028C1.4826 28.9708 3.02916 30.5174 4.99717 31.0442C8.56067 32 22.8561 32 22.8561 32C22.8561 32 37.1514 32 40.7149 31.0442C42.6829 30.5174 44.2295 28.9708 44.7563 27.0028C45.7121 23.4393 45.7121 16 45.7121 16C45.7121 16 45.7121 8.56068 44.7563 4.99718H44.7601Z" fill="#E70000"/>
        <path d="M18.2842 22.8561L30.1638 16L18.2842 9.14392V22.8561Z" fill="#FEFEFE"/>
      </g>
      <defs>
        <clipPath id="clip0_2388_1553">
          <rect width="45.7121" height="32" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `;

  css = () => `
    
  `;
}
